module.exports = __webpack_public_path__ + "img/hospice-west-logo.fb321d72.jpg";